export enum VidyoCalendarConnectResult {
  "VIDYO_CALENDARCONNECTRESULT_Ok",
  "VIDYO_CALENDARCONNECTRESULT_NoService",
  "VIDYO_CALENDARCONNECTRESULT_ConnectionFailed",
  "VIDYO_CALENDARCONNECTRESULT_ConnectionLost",
  "VIDYO_CALENDARCONNECTRESULT_ConnectionTimeout",
  "VIDYO_CALENDARCONNECTRESULT_InvalidCredentials",
  "VIDYO_CALENDARCONNECTRESULT_InvalidCalendarId",
  "VIDYO_CALENDARCONNECTRESULT_Disconnected",
  "VIDYO_CALENDARCONNECTRESULT_GeneralError",
}
export enum VidyoCalendarManagerGetServicesResult {
  "VIDYO_CALENDARMANAGERGETSERVICESRESULT_SUCCESS",
  "VIDYO_CALENDARMANAGERGETSERVICESRESULT_MiscError",
}
export enum VidyoCalendarServiceStatus {
  "VIDYO_CALENDARSERVICESTATUS_Init",
  "VIDYO_CALENDARSERVICESTATUS_Loaded",
  "VIDYO_CALENDARSERVICESTATUS_LoadError",
  "VIDYO_CALENDARSERVICESTATUS_InvalidVersion",
  "VIDYO_CALENDARSERVICESTATUS_DllNotFound",
  "VIDYO_CALENDARSERVICESTATUS_ApiProcError",
  "VIDYO_CALENDARSERVICESTATUS_PluginSvcNotInstalled",
  "VIDYO_CALENDARSERVICESTATUS_PluginSvcNotActive",
  "VIDYO_CALENDARSERVICESTATUS_PluginSvcAuthRequired",
  "VIDYO_CALENDARSERVICESTATUS_Unloaded",
}
export enum VidyoFormFieldTextWrapMode {
  "VIDYO_FORMFIELDTEXTWRAPMODE_Off",
  "VIDYO_FORMFIELDTEXTWRAPMODE_Virtual",
  "VIDYO_FORMFIELDTEXTWRAPMODE_Physical",
}
export enum VidyoFormFieldType {
  "VIDYO_FORMFIELDTYPE_Text",
  "VIDYO_FORMFIELDTYPE_TextArea",
  "VIDYO_FORMFIELDTYPE_Password",
  "VIDYO_FORMFIELDTYPE_Checkbox",
  "VIDYO_FORMFIELDTYPE_Radio",
  "VIDYO_FORMFIELDTYPE_Select",
}
export enum VidyoCalendarCapabilityKey {
  "VIDYO_CALENDARCAPABILITYKEY_SSO",
  "VIDYO_CALENDARCAPABILITYKEY_WebUrl",
  "VIDYO_CALENDARCAPABILITYKEY_WebUrlAutodiscovery",
  "VIDYO_CALENDARCAPABILITYKEY_Username",
  "VIDYO_CALENDARCAPABILITYKEY_Password",
}
export enum VidyoCalendarCreateCode {
  "VIDYO_CALENDARCREATECODE_Ok",
  "VIDYO_CALENDARCREATECODE_SvcNotRegistered",
  "VIDYO_CALENDARCREATECODE_LibraryLoadFailed",
  "VIDYO_CALENDARCREATECODE_ExistingInstance",
  "VIDYO_CALENDARCREATECODE_CalendarPluginConstructFailure",
  "VIDYO_CALENDARCREATECODE_CalendarPluginInvalidCredentials",
  "VIDYO_CALENDARCREATECODE_CalendarPluginInvalidCalendarId",
  "VIDYO_CALENDARCREATECODE_VidyoCalendarConstructFailure",
  "VIDYO_CALENDARCREATECODE_VidyoCalendarDestroyed",
  "VIDYO_CALENDARCREATECODE_GeneralError",
}
export enum VidyoCalendarState {
  "VIDYO_CALENDARSTATE_Unavailable",
  "VIDYO_CALENDARSTATE_Initialized",
  "VIDYO_CALENDARSTATE_Connecting",
  "VIDYO_CALENDARSTATE_Connected",
  "VIDYO_CALENDARSTATE_Disconnecting",
  "VIDYO_CALENDARSTATE_Disconnected",
}
export enum VidyoMeetingSearchResult {
  "VIDYO_MEETINGSEARCHRESULT_Ok",
  "VIDYO_MEETINGSEARCHRESULT_Processing",
  "VIDYO_MEETINGSEARCHRESULT_NoRecords",
  "VIDYO_MEETINGSEARCHRESULT_InvalidIndex",
  "VIDYO_MEETINGSEARCHRESULT_InvalidDateTimeRange",
  "VIDYO_MEETINGSEARCHRESULT_NoResponse",
  "VIDYO_MEETINGSEARCHRESULT_NotConnected",
  "VIDYO_MEETINGSEARCHRESULT_PluginError",
  "VIDYO_MEETINGSEARCHRESULT_MiscLocalError",
  "VIDYO_MEETINGSEARCHRESULT_MiscRemoteError",
}
export enum VidyoConnectorAnalyticsEventAction {
  "VIDYO_CONNECTORANALYTICSEVENTACTION_LoginSuccess",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_LoginAttempt",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_LoginFailedAuthentication",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_LoginFailedConnect",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_LoginFailedResponseTimeout",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_LoginFailedMiscError",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_LoginFailedWebProxyAuthRequired",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_LoginFailedUnsupportedTenantVersion",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_UserTypeGuest",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_UserTypeRegularToken",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_UserTypeRegularPassword",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_UserTypeRegularSaml",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_UserTypeRegularExtdata",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceSuccess",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceAttempt",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceReconnectRequests",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceFailedConnectionError",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceFailedWrongPin",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceFailedRoomFull",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceFailedRoomDisabled",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceFailedConferenceLocked",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_JoinConferenceFailedUnknownError",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_ConferenceEndLeft",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_ConferenceEndBooted",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_ConferenceEndSignalingConnectionLost",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_ConferenceEndMediaConnectionLost",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_ConferenceEndUnknownError",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_InCallCodecVideoH264",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_InCallCodecVideoH264SVC",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_InCallCodecAudioSPEEXRED",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_All",
  "VIDYO_CONNECTORANALYTICSEVENTACTION_Unknown",
}
export enum VidyoConnectorAnalyticsEventCategory {
  "VIDYO_CONNECTORANALYTICSEVENTCATEGORY_Login",
  "VIDYO_CONNECTORANALYTICSEVENTCATEGORY_UserType",
  "VIDYO_CONNECTORANALYTICSEVENTCATEGORY_JoinConference",
  "VIDYO_CONNECTORANALYTICSEVENTCATEGORY_ConferenceEnd",
  "VIDYO_CONNECTORANALYTICSEVENTCATEGORY_InCallCodec",
  "VIDYO_CONNECTORANALYTICSEVENTCATEGORY_None",
}
export enum VidyoConnectorAnalyticsServiceType {
  "VIDYO_CONNECTORANALYTICSSERVICETYPE_Google",
  "VIDYO_CONNECTORANALYTICSSERVICETYPE_VidyoInsights",
  "VIDYO_CONNECTORANALYTICSSERVICETYPE_None",
}
export enum VidyoConnectorBaseTransportType {
  "VIDYO_CONNECTORBASETRANSPORTTYPE_TLS",
  "VIDYO_CONNECTORBASETRANSPORTTYPE_TCP",
  "VIDYO_CONNECTORBASETRANSPORTTYPE_UDP",
}
export enum VidyoConnectorCameraEffectError {
  "VIDYO_CONNECTORCAMERAEFFECTERROR_None",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_InvalidToken",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_InvalidResources",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_InvalidEffect",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_InvalidBlurIntensity",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_InvalidBackgroundPicture",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_LoadEffectFailed",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_UnsupportedOpenGLVersion",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_UnsupportedLibraryVersion",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_NotAllowedForCurrectEffect",
  "VIDYO_CONNECTORCAMERAEFFECTERROR_MiscError",
}
export enum VidyoConnectorCameraEffectType {
  "VIDYO_CONNECTORCAMERAEFFECTTYPE_None",
  "VIDYO_CONNECTORCAMERAEFFECTTYPE_Blur",
  "VIDYO_CONNECTORCAMERAEFFECTTYPE_VirtualBackground",
}
export enum VidyoConnectorConferenceHostState {
  "VIDYO_CONNECTORCONFERENCEHOSTSTATE_JOINED",
  "VIDYO_CONNECTORCONFERENCEHOSTSTATE_LEFT",
}
export enum VidyoConnectorConferenceMode {
  "VIDYO_CONNECTORCONFERENCEMODE_LOBBY",
  "VIDYO_CONNECTORCONFERENCEMODE_LECTURE",
  "VIDYO_CONNECTORCONFERENCEMODE_GROUP",
}
export enum VidyoConnectorDisconnectReason {
  VIDYO_CONNECTORDISCONNECTREASON_Disconnected = "VIDYO_CONNECTORDISCONNECTREASON_Disconnected",
  VIDYO_CONNECTORDISCONNECTREASON_ConnectionLost = "VIDYO_CONNECTORDISCONNECTREASON_ConnectionLost",
  VIDYO_CONNECTORDISCONNECTREASON_ConnectionTimeout = "VIDYO_CONNECTORDISCONNECTREASON_ConnectionTimeout",
  VIDYO_CONNECTORDISCONNECTREASON_NoResponse = "VIDYO_CONNECTORDISCONNECTREASON_NoResponse",
  VIDYO_CONNECTORDISCONNECTREASON_Terminated = "VIDYO_CONNECTORDISCONNECTREASON_Terminated",
  VIDYO_CONNECTORDISCONNECTREASON_Booted = "VIDYO_CONNECTORDISCONNECTREASON_Booted",
  VIDYO_CONNECTORDISCONNECTREASON_MiscLocalError = "VIDYO_CONNECTORDISCONNECTREASON_MiscLocalError",
  VIDYO_CONNECTORDISCONNECTREASON_MiscRemoteError = "VIDYO_CONNECTORDISCONNECTREASON_MiscRemoteError",
  VIDYO_CONNECTORDISCONNECTREASON_MiscError = "VIDYO_CONNECTORDISCONNECTREASON_MiscError",
}
export enum VidyoConnectorErrorCode {
  "VIDYO_CONNECTORERRORCODE_NotAllowed",
  "VIDYO_CONNECTORERRORCODE_WrongState",
  "VIDYO_CONNECTORERRORCODE_InvalidInput",
  "VIDYO_CONNECTORERRORCODE_Misc",
}
export enum VidyoConnectorFailReason {
  "VIDYO_CONNECTORFAILREASON_ConnectionFailed",
  "VIDYO_CONNECTORFAILREASON_ConnectionLost",
  "VIDYO_CONNECTORFAILREASON_ConnectionTimeout",
  "VIDYO_CONNECTORFAILREASON_NoResponse",
  "VIDYO_CONNECTORFAILREASON_Terminated",
  "VIDYO_CONNECTORFAILREASON_InvalidToken",
  "VIDYO_CONNECTORFAILREASON_UnableToCreateResource",
  "VIDYO_CONNECTORFAILREASON_NoResponseFromResource",
  "VIDYO_CONNECTORFAILREASON_InvalidResourceId",
  "VIDYO_CONNECTORFAILREASON_ResourceFull",
  "VIDYO_CONNECTORFAILREASON_NotMember",
  "VIDYO_CONNECTORFAILREASON_Banned",
  "VIDYO_CONNECTORFAILREASON_MediaNotEnabled",
  "VIDYO_CONNECTORFAILREASON_MediaFailed",
  "VIDYO_CONNECTORFAILREASON_MiscLocalError",
  "VIDYO_CONNECTORFAILREASON_MiscRemoteError",
  "VIDYO_CONNECTORFAILREASON_MiscError",
  "VIDYO_CONNECTORFAILREASON_InvalidDisplayNameLength",
  "VIDYO_CONNECTORFAILREASON_RoomLocked",
  "VIDYO_CONNECTORFAILREASON_RoomDisabled",
  "VIDYO_CONNECTORFAILREASON_AllLinesInUse",
  "VIDYO_CONNECTORFAILREASON_SeatLicenseExpired",
  "VIDYO_CONNECTORFAILREASON_NotLicensed",
  "VIDYO_CONNECTORFAILREASON_Rejected",
  "VIDYO_CONNECTORFAILREASON_BrowserVersionNotSupported",
}
export enum VidyoConnectorInCallEventClass {
  "VIDYO_CONNECTORINCALLEVENTCLASS_MediaTransport",
  "VIDYO_CONNECTORINCALLEVENTCLASS_InCallCodec",
  "VIDYO_CONNECTORINCALLEVENTCLASS_UnKnown",
}
export enum VidyoConnectorInCallEventCode {
  "VIDYO_CONNECTORINCALLEVENTCODE_RTCPSendError",
  "VIDYO_CONNECTORINCALLEVENTCODE_RTCPReceiveError",
  "VIDYO_CONNECTORINCALLEVENTCODE_RTPSendError",
  "VIDYO_CONNECTORINCALLEVENTCODE_RTPReceiveError",
  "VIDYO_CONNECTORINCALLEVENTCODE_EncoderPausedOnLowBW",
  "VIDYO_CONNECTORINCALLEVENTCODE_EncoderResumed",
  "VIDYO_CONNECTORINCALLEVENTCODE_InCallCodecVideoH264",
  "VIDYO_CONNECTORINCALLEVENTCODE_InCallCodecVideoH264SVC",
  "VIDYO_CONNECTORINCALLEVENTCODE_InCallCodecAudioSPEEXRED",
  "VIDYO_CONNECTORINCALLEVENTCODE_UnKnown",
}
export enum VidyoConnectorLogLevel {
  "VIDYO_CONNECTORLOGLEVEL_PRODUCTION",
  "VIDYO_CONNECTORLOGLEVEL_DEBUG",
  "VIDYO_CONNECTORLOGLEVEL_INVALID",
}
export enum VidyoConnectorLoggerType {
  "VIDYO_CONNECTORLOGGERTYPE_CONSOLE",
  "VIDYO_CONNECTORLOGGERTYPE_FILE",
  "VIDYO_CONNECTORLOGGERTYPE_FEEDBACK",
  "VIDYO_CONNECTORLOGGERTYPE_HTTP",
}
export enum VidyoConnectorMode {
  "VIDYO_CONNECTORMODE_Default",
  "VIDYO_CONNECTORMODE_Foreground",
  "VIDYO_CONNECTORMODE_Background",
}
export enum VidyoConnectorModerationActionType {
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_Mute",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_Unmute",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_StartLectureMode",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_StopLectureMode",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_SetPresenter",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_RemovePresenter",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_RaiseHand",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_UnraiseHand",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_DismissRaisedHand",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_DismissAllRaisedHands",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_SetModeratorPin",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_RemoveModeratorPin",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_DisconnectAll",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_DisconnectOne",
  "VIDYO_CONNECTORMODERATIONACTIONTYPE_Invalid",
}
export enum VidyoConnectorModerationResult {
  "VIDYO_CONNECTORMODERATIONRESULT_OK",
  "VIDYO_CONNECTORMODERATIONRESULT_NoResponse",
  "VIDYO_CONNECTORMODERATIONRESULT_Unauthorized",
  "VIDYO_CONNECTORMODERATIONRESULT_NotOwnerOfRoom",
  "VIDYO_CONNECTORMODERATIONRESULT_NotAcceptable",
  "VIDYO_CONNECTORMODERATIONRESULT_NotAllowed",
  "VIDYO_CONNECTORMODERATIONRESULT_Conflict",
  "VIDYO_CONNECTORMODERATIONRESULT_InvalidInput",
  "VIDYO_CONNECTORMODERATIONRESULT_OutOfResources",
  "VIDYO_CONNECTORMODERATIONRESULT_UserIsOffline",
  "VIDYO_CONNECTORMODERATIONRESULT_RoomFull",
  "VIDYO_CONNECTORMODERATIONRESULT_MiscLocalError",
  "VIDYO_CONNECTORMODERATIONRESULT_MiscRemoteError",
}
export enum VidyoConnectorRecordingServiceResult {
  "VIDYO_CONNECTORRECORDINGSERVICERESULT_Success",
  "VIDYO_CONNECTORRECORDINGSERVICERESULT_InvalidArgument",
  "VIDYO_CONNECTORRECORDINGSERVICERESULT_GeneralFailure",
  "VIDYO_CONNECTORRECORDINGSERVICERESULT_SeatLicenseExpired",
  "VIDYO_CONNECTORRECORDINGSERVICERESULT_NotLicensed",
  "VIDYO_CONNECTORRECORDINGSERVICERESULT_ResourceNotAvailable",
  "VIDYO_CONNECTORRECORDINGSERVICERESULT_ControlMeetingFailure",
}
export enum VidyoConnectorRecordingState {
  "VIDYO_CONNECTORRECORDINGSTATE_NotRecording",
  "VIDYO_CONNECTORRECORDINGSTATE_RecordingPaused",
  "VIDYO_CONNECTORRECORDINGSTATE_Recording",
}
export enum VidyoConnectorSearchResult {
  "VIDYO_CONNECTORSEARCHRESULT_Ok",
  "VIDYO_CONNECTORSEARCHRESULT_NoRecords",
  "VIDYO_CONNECTORSEARCHRESULT_NoResponse",
  "VIDYO_CONNECTORSEARCHRESULT_MiscLocalError",
  "VIDYO_CONNECTORSEARCHRESULT_MiscRemoteError",
}
export enum VidyoConnectorState {
  "VIDYO_CONNECTORSTATE_Idle",
  "VIDYO_CONNECTORSTATE_Ready",
  "VIDYO_CONNECTORSTATE_EstablishingConnection",
  "VIDYO_CONNECTORSTATE_FindingResource",
  "VIDYO_CONNECTORSTATE_ConnectingToResource",
  "VIDYO_CONNECTORSTATE_EnablingMedia",
  "VIDYO_CONNECTORSTATE_Connected",
  "VIDYO_CONNECTORSTATE_Disconnecting",
  "VIDYO_CONNECTORSTATE_Disabling",
  "VIDYO_CONNECTORSTATE_Dead",
}
export enum VidyoConnectorTradeOffProfile {
  "VIDYO_CONNECTORTRADEOFFPROFILE_High",
  "VIDYO_CONNECTORTRADEOFFPROFILE_Medium",
  "VIDYO_CONNECTORTRADEOFFPROFILE_Low",
}
export enum VidyoConnectorViewStyle {
  "VIDYO_CONNECTORVIEWSTYLE_Default",
  "VIDYO_CONNECTORVIEWSTYLE_Tiles",
}
export enum VidyoConnectorWebcastingState {
  "VIDYO_CONNECTORWEBCASTINGSTATE_NotWebcasting",
  "VIDYO_CONNECTORWEBCASTINGSTATE_Webcasting",
}
export enum VidyoGatewayDisconnectReason {
  "VIDYO_GATEWAYDISCONNECTREASON_Disconnected",
  "VIDYO_GATEWAYDISCONNECTREASON_ConnectionLost",
  "VIDYO_GATEWAYDISCONNECTREASON_ConnectionTimeout",
  "VIDYO_GATEWAYDISCONNECTREASON_NoResponse",
  "VIDYO_GATEWAYDISCONNECTREASON_Terminated",
  "VIDYO_GATEWAYDISCONNECTREASON_MiscLocalError",
  "VIDYO_GATEWAYDISCONNECTREASON_MiscRemoteError",
  "VIDYO_GATEWAYDISCONNECTREASON_MiscError",
}
export enum VidyoGatewayFailReason {
  "VIDYO_GATEWAYFAILREASON_ConnectionFailed",
  "VIDYO_GATEWAYFAILREASON_ConnectionLost",
  "VIDYO_GATEWAYFAILREASON_ConnectionTimeout",
  "VIDYO_GATEWAYFAILREASON_NoResponse",
  "VIDYO_GATEWAYFAILREASON_Terminated",
  "VIDYO_GATEWAYFAILREASON_InvalidToken",
  "VIDYO_GATEWAYFAILREASON_UnableToCreateResource",
  "VIDYO_GATEWAYFAILREASON_NoResponseFromResource",
  "VIDYO_GATEWAYFAILREASON_InvalidResourceId",
  "VIDYO_GATEWAYFAILREASON_ResourceFull",
  "VIDYO_GATEWAYFAILREASON_NotMember",
  "VIDYO_GATEWAYFAILREASON_Banned",
  "VIDYO_GATEWAYFAILREASON_MediaNotEnabled",
  "VIDYO_GATEWAYFAILREASON_MediaFailed",
  "VIDYO_GATEWAYFAILREASON_MiscLocalError",
  "VIDYO_GATEWAYFAILREASON_MiscRemoteError",
  "VIDYO_GATEWAYFAILREASON_MiscError",
}
export enum VidyoGatewayState {
  "VIDYO_GATEWAYSTATE_Idle",
  "VIDYO_GATEWAYSTATE_EstablishingConnection",
  "VIDYO_GATEWAYSTATE_FindingResource",
  "VIDYO_GATEWAYSTATE_ConnectingToResource",
  "VIDYO_GATEWAYSTATE_EnablingMedia",
  "VIDYO_GATEWAYSTATE_Connected",
}
export enum VidyoCameraControlDirection {
  "VIDYO_CAMERACONTROLDIRECTION_PanLeft",
  "VIDYO_CAMERACONTROLDIRECTION_PanRight",
  "VIDYO_CAMERACONTROLDIRECTION_TiltUp",
  "VIDYO_CAMERACONTROLDIRECTION_TiltDown",
  "VIDYO_CAMERACONTROLDIRECTION_ZoomIn",
  "VIDYO_CAMERACONTROLDIRECTION_ZoomOut",
}
export enum VidyoDeviceAudioSignalType {
  "VIDYO_DEVICEAUDIOSIGNALTYPE_Voice",
  "VIDYO_DEVICEAUDIOSIGNALTYPE_Unprocessed",
}
export enum VidyoDeviceOrientation {
  "VIDYO_DEVICEORIENTATION_UP",
  "VIDYO_DEVICEORIENTATION_DOWN",
  "VIDYO_DEVICEORIENTATION_LEFT",
  "VIDYO_DEVICEORIENTATION_RIGHT",
}
export enum VidyoDeviceState {
  "VIDYO_DEVICESTATE_Added",
  "VIDYO_DEVICESTATE_Removed",
  "VIDYO_DEVICESTATE_Started",
  "VIDYO_DEVICESTATE_Stopped",
  "VIDYO_DEVICESTATE_Suspended",
  "VIDYO_DEVICESTATE_Unsuspended",
  "VIDYO_DEVICESTATE_InUse",
  "VIDYO_DEVICESTATE_Available",
  "VIDYO_DEVICESTATE_Paused",
  "VIDYO_DEVICESTATE_Resumed",
  "VIDYO_DEVICESTATE_ControlledByRemoteEntity",
  "VIDYO_DEVICESTATE_NotControlledByRemoteEntity",
  "VIDYO_DEVICESTATE_Controllable",
  "VIDYO_DEVICESTATE_NotControllable",
  "VIDYO_DEVICESTATE_DefaultChanged",
  "VIDYO_DEVICESTATE_ConfigureSuccess",
  "VIDYO_DEVICESTATE_ConfigureError",
  "VIDYO_DEVICESTATE_ConfigurationChanged",
  "VIDYO_DEVICESTATE_Error",
  "VIDYO_DEVICESTATE_UnableGetDeviceData",
  "VIDYO_DEVICESTATE_UnexpectedEvent",
}
export enum VidyoDeviceType {
  VIDYO_DEVICETYPE_LocalCamera = "VIDYO_DEVICETYPE_LocalCamera",
  VIDYO_DEVICETYPE_LocalMicrophone = "VIDYO_DEVICETYPE_LocalMicrophone",
  VIDYO_DEVICETYPE_LocalMonitor = "VIDYO_DEVICETYPE_LocalMonitor",
  VIDYO_DEVICETYPE_LocalWindowShare = "VIDYO_DEVICETYPE_LocalWindowShare",
  VIDYO_DEVICETYPE_LocalSpeaker = "VIDYO_DEVICETYPE_LocalSpeaker",
  VIDYO_DEVICETYPE_LocalRenderer = "VIDYO_DEVICETYPE_LocalRenderer",
  VIDYO_DEVICETYPE_RemoteCamera = "VIDYO_DEVICETYPE_RemoteCamera",
  VIDYO_DEVICETYPE_RemoteMicrophone = "VIDYO_DEVICETYPE_RemoteMicrophone",
  VIDYO_DEVICETYPE_RemoteWindowShare = "VIDYO_DEVICETYPE_RemoteWindowShare",
  VIDYO_DEVICETYPE_RemoteSpeaker = "VIDYO_DEVICETYPE_RemoteSpeaker",
  VIDYO_DEVICETYPE_RemoteRenderer = "VIDYO_DEVICETYPE_RemoteRenderer",
  VIDYO_DEVICETYPE_VirtualVideoSource = "VIDYO_DEVICETYPE_VirtualVideoSource",
  VIDYO_DEVICETYPE_VirtualAudioSource = "VIDYO_DEVICETYPE_VirtualAudioSource",
}
export enum VidyoLocalCameraPosition {
  "VIDYO_LOCALCAMERAPOSITION_Unknown",
  "VIDYO_LOCALCAMERAPOSITION_Front",
  "VIDYO_LOCALCAMERAPOSITION_Back",
}
export enum VidyoLocalCameraTradeOffProfile {
  "VIDYO_LOCALCAMERATRADEOFFPROFILE_High",
  "VIDYO_LOCALCAMERATRADEOFFPROFILE_Medium",
  "VIDYO_LOCALCAMERATRADEOFFPROFILE_Low",
}
export enum VidyoVoiceProcessingMode {
  "VIDYO_VOICEPROCESSINGMODE_Default",
  "VIDYO_VOICEPROCESSINGMODE_Vidyo",
  "VIDYO_VOICEPROCESSINGMODE_Platform",
}
export enum VidyoLocalMonitorState {
  "VIDYO_LOCALMONITORSTATE_Ok",
  "VIDYO_LOCALMONITORSTATE_NotVisible",
  "VIDYO_LOCALMONITORSTATE_MiscError",
}
export enum VidyoLocalRendererBorderStyle {
  "VIDYO_LOCALRENDERERBORDERSTYLE_None",
  "VIDYO_LOCALRENDERERBORDERSTYLE_Same",
  "VIDYO_LOCALRENDERERBORDERSTYLE_Highlight",
  "VIDYO_LOCALRENDERERBORDERSTYLE_Flash",
}
export enum VidyoLocalRendererPipPosition {
  "VIDYO_LOCALRENDERERPIPPOSITION_MIN",
  "VIDYO_LOCALRENDERERPIPPOSITION_CENTER",
  "VIDYO_LOCALRENDERERPIPPOSITION_MAX",
}
export enum VidyoLocalRendererViewStyle {
  "VIDYO_LOCALRENDERERVIEWSTYLE_Default",
  "VIDYO_LOCALRENDERERVIEWSTYLE_Tiles",
  "VIDYO_LOCALRENDERERVIEWSTYLE_TilesWithRemoteCameraControlV2",
}
export enum VidyoLocalWindowShareState {
  "VIDYO_LOCALWINDOWSHARESTATE_Ok",
  "VIDYO_LOCALWINDOWSHARESTATE_NotVisible",
  "VIDYO_LOCALWINDOWSHARESTATE_Minimized",
  "VIDYO_LOCALWINDOWSHARESTATE_Closed",
  "VIDYO_LOCALWINDOWSHARESTATE_MiscError",
}
export enum VidyoRemoteCameraMode {
  "VIDYO_REMOTECAMERAMODE_Dynamic",
  "VIDYO_REMOTECAMERAMODE_Static",
}
export enum VidyoRemoteCameraPosition {
  "VIDYO_REMOTECAMERAPOSITION_Unknown",
  "VIDYO_REMOTECAMERAPOSITION_Front",
  "VIDYO_REMOTECAMERAPOSITION_Back",
}
export enum VidyoRemoteMicrophoneMode {
  "VIDYO_REMOTEMICROPHONEMODE_Dynamic",
  "VIDYO_REMOTEMICROPHONEMODE_Static",
}
export enum VidyoVirtualVideoSourceType {
  "VIDYO_VIRTUALVIDEOSOURCETYPE_SHARE",
  "VIDYO_VIRTUALVIDEOSOURCETYPE_CAMERA",
}
export enum VidyoVirtualWindowShareState {
  "VIDYO_VIRTUALWINDOWSHARESTATE_Ok",
  "VIDYO_VIRTUALWINDOWSHARESTATE_NotVisible",
  "VIDYO_VIRTUALWINDOWSHARESTATE_Minimized",
  "VIDYO_VIRTUALWINDOWSHARESTATE_Closed",
  "VIDYO_VIRTUALWINDOWSHARESTATE_MiscError",
}
export enum VidyoApplicationDownloadFailedReason {
  "VIDYO_APPLICATION_DOWNLOADFAILEDREASON_WebProxyAuthenticationRequired",
  "VIDYO_APPLICATION_DOWNLOADFAILEDREASON_MiscError",
}
export enum VidyoCallEndReason {
  "VIDYO_CALLENDREASON_Ended",
  "VIDYO_CALLENDREASON_ConnectionFailed",
  "VIDYO_CALLENDREASON_ConnectionLost",
  "VIDYO_CALLENDREASON_ParticipantBusy",
  "VIDYO_CALLENDREASON_ParticipantRejected",
  "VIDYO_CALLENDREASON_ParticipantEnded",
  "VIDYO_CALLENDREASON_MiscError",
}
export enum VidyoCallInitiatedResult {
  "VIDYO_CALLINITIATEDRESULT_OK",
  "VIDYO_CALLINITIATEDRESULT_Cancelled",
  "VIDYO_CALLINITIATEDRESULT_NoResponse",
  "VIDYO_CALLINITIATEDRESULT_UnknownParticipant",
  "VIDYO_CALLINITIATEDRESULT_MiscLocalError",
  "VIDYO_CALLINITIATEDRESULT_MiscRemoteError",
}
export enum VidyoChatMessageSenderType {
  "VIDYO_CHATMESSAGESENDERTYPE_User",
  "VIDYO_CHATMESSAGESENDERTYPE_Room",
  "VIDYO_CHATMESSAGESENDERTYPE_System",
  "VIDYO_CHATMESSAGESENDERTYPE_None",
}
export enum VidyoChatMessageType {
  "VIDYO_CHATMESSAGETYPE_Chat",
  "VIDYO_CHATMESSAGETYPE_MediaStart",
  "VIDYO_CHATMESSAGETYPE_MediaStop",
  "VIDYO_CHATMESSAGETYPE_PrivateChat",
}
export enum VidyoChatMessageTypingIndication {
  "VIDYO_CHATMESSAGETYPINGINDICATION_Active",
  "VIDYO_CHATMESSAGETYPINGINDICATION_Composing",
  "VIDYO_CHATMESSAGETYPINGINDICATION_Gone",
  "VIDYO_CHATMESSAGETYPINGINDICATION_Inactive",
  "VIDYO_CHATMESSAGETYPINGINDICATION_Paused",
  "VIDYO_CHATMESSAGETYPINGINDICATION_None",
}
export enum VidyoContactPresenceState {
  "VIDYO_CONTACTPRESENCESTATE_Unavailable",
  "VIDYO_CONTACTPRESENCESTATE_DoNotDisturb",
  "VIDYO_CONTACTPRESENCESTATE_ExtendedAway",
  "VIDYO_CONTACTPRESENCESTATE_Away",
  "VIDYO_CONTACTPRESENCESTATE_Available",
  "VIDYO_CONTACTPRESENCESTATE_InterestedInChat",
}
export enum VidyoContactSubscriptionState {
  "VIDYO_CONTACTSUBSCRIPTIONSTATE_Unavailable",
  "VIDYO_CONTACTSUBSCRIPTIONSTATE_NotSubscribed",
  "VIDYO_CONTACTSUBSCRIPTIONSTATE_Preapproved",
  "VIDYO_CONTACTSUBSCRIPTIONSTATE_AwaitingApproval",
  "VIDYO_CONTACTSUBSCRIPTIONSTATE_Subscribed",
}
export enum VidyoContactInfoPresenceState {
  "VIDYO_CONTACTINFOPRESENCESTATE_Unavailable",
  "VIDYO_CONTACTINFOPRESENCESTATE_DoNotDisturb",
  "VIDYO_CONTACTINFOPRESENCESTATE_ExtendedAway",
  "VIDYO_CONTACTINFOPRESENCESTATE_Away",
  "VIDYO_CONTACTINFOPRESENCESTATE_Available",
  "VIDYO_CONTACTINFOPRESENCESTATE_InterestedInChat",
}
export enum VidyoClientAppLogLevel {
  "VIDYO_CLIENTAPPLOGLEVEL_Info",
  "VIDYO_CLIENTAPPLOGLEVEL_Debug",
  "VIDYO_CLIENTAPPLOGLEVEL_Warning",
  "VIDYO_CLIENTAPPLOGLEVEL_Error",
}
export enum VidyoEndpointAnalyticsEventAction {
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_LoginSuccess",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_LoginAttempt",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_LoginFailedAuthentication",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_LoginFailedConnect",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_LoginFailedResponseTimeout",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_LoginFailedMiscError",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_LoginFailedWebProxyAuthRequired",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_LoginFailedUnsupportedTenantVersion",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_UserTypeGuest",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_UserTypeRegularToken",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_UserTypeRegularPassword",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_UserTypeRegularSaml",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_UserTypeRegularExtdata",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceSuccess",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceAttempt",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceReconnectRequests",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceFailedConnectionError",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceFailedWrongPin",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceFailedRoomFull",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceFailedRoomDisabled",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceFailedConferenceLocked",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_JoinConferenceFailedUnknownError",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_ConferenceEndLeft",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_ConferenceEndBooted",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_ConferenceEndSignalingConnectionLost",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_ConferenceEndMediaConnectionLost",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_ConferenceEndUnknownError",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_InCallCodecVideoH264",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_InCallCodecVideoH264SVC",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_InCallCodecAudioSPEEXRED",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_All",
  "VIDYO_ENDPOINTANALYTICSEVENTACTION_Unknown",
}
export enum VidyoEndpointAnalyticsEventCategory {
  "VIDYO_ENDPOINTANALYTICSEVENTCATEGORY_Login",
  "VIDYO_ENDPOINTANALYTICSEVENTCATEGORY_UserType",
  "VIDYO_ENDPOINTANALYTICSEVENTCATEGORY_JoinConference",
  "VIDYO_ENDPOINTANALYTICSEVENTCATEGORY_ConferenceEnd",
  "VIDYO_ENDPOINTANALYTICSEVENTCATEGORY_InCallCodec",
  "VIDYO_ENDPOINTANALYTICSEVENTCATEGORY_None",
}
export enum VidyoEndpointAnalyticsServiceType {
  "VIDYO_ENDPOINTANALYTICSSERVICETYPE_Google",
  "VIDYO_ENDPOINTANALYTICSSERVICETYPE_VidyoInsights",
  "VIDYO_ENDPOINTANALYTICSSERVICETYPE_None",
}
export enum VidyoEndpointBaseTransportType {
  "VIDYO_ENDPOINTBASETRANSPORTTYPE_TLS",
  "VIDYO_ENDPOINTBASETRANSPORTTYPE_TCP",
  "VIDYO_ENDPOINTBASETRANSPORTTYPE_UDP",
}
export enum VidyoEndpointCameraEffectError {
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_None",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_InvalidToken",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_InvalidResources",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_InvalidEffect",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_InvalidBlurIntensity",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_InvalidBackgroundPicture",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_LoadEffectFailed",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_UnsupportedOpenGLVersion",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_UnsupportedLibraryVersion",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_NotAllowedForCurrectEffect",
  "VIDYO_ENDPOINTCAMERAEFFECTERROR_MiscError",
}
export enum VidyoEndpointCameraEffectType {
  "VIDYO_ENDPOINTCAMERAEFFECTTYPE_None",
  "VIDYO_ENDPOINTCAMERAEFFECTTYPE_Blur",
  "VIDYO_ENDPOINTCAMERAEFFECTTYPE_VirtualBackground",
}
export enum VidyoEndpointErrorCode {
  "VIDYO_ENDPOINTERRORCODE_NotAllowed",
  "VIDYO_ENDPOINTERRORCODE_WrongState",
  "VIDYO_ENDPOINTERRORCODE_InvalidInput",
  "VIDYO_ENDPOINTERRORCODE_Misc",
}
export enum VidyoEndpointGetLoggerCategoryListResult {
  "VIDYO_ENDPOINTGETLOGGERCATEGORYLISTRESULT_SUCCESS",
  "VIDYO_ENDPOINTGETLOGGERCATEGORYLISTRESULT_MiscError",
}
export enum VidyoEndpointLogCompressionResult {
  "VIDYO_ENDPOINTLOGCOMPRESSIONRESULT_Success",
  "VIDYO_ENDPOINTLOGCOMPRESSIONRESULT_MiscError",
}
export enum VidyoEndpointLoggerType {
  "VIDYO_ENDPOINTLOGGERTYPE_CONSOLE",
  "VIDYO_ENDPOINTLOGGERTYPE_FILE",
  "VIDYO_ENDPOINTLOGGERTYPE_FEEDBACK",
  "VIDYO_ENDPOINTLOGGERTYPE_HTTP",
}
export enum VidyoEndpointMediaState {
  "VIDYO_ENDPOINTMEDIASTATE_Idle",
  "VIDYO_ENDPOINTMEDIASTATE_GreenRoom",
  "VIDYO_ENDPOINTMEDIASTATE_Live",
}
export enum VidyoEndpointMode {
  "VIDYO_ENDPOINTMODE_Default",
  "VIDYO_ENDPOINTMODE_Foreground",
  "VIDYO_ENDPOINTMODE_Background",
}
export enum VidyoEndpointReconnectFailReason {
  "VIDYO_ENDPOINTRECONNECTFAILREASON_Cancelled",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_NoConference",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_SignalingConnectionLost",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_MediaConnectionLost",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_NoResponse",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_InvalidPassword",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_RoomIsFull",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_InvalidRoomKey",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_RoomDisabled",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_AllLinesInUse",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_ConnectionError",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_InvalidRoom",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_ConferenceLocked",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_SeatLicenseExpired",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_NotLicensed",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_Rejected",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_UnknownError",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_MiscLocalError",
  "VIDYO_ENDPOINTRECONNECTFAILREASON_MiscRemoteError",
}
export enum VidyoEndpointTone {
  "VIDYO_ENDPOINTTONE_Join",
  "VIDYO_ENDPOINTTONE_Leave",
  "VIDYO_ENDPOINTTONE_MsgRecv",
  "VIDYO_ENDPOINTTONE_MsgSend",
  "VIDYO_ENDPOINTTONE_Ring",
  "VIDYO_ENDPOINTTONE_Max",
}
export enum VidyoEndpointTradeOffProfile {
  "VIDYO_ENDPOINTTRADEOFFPROFILE_High",
  "VIDYO_ENDPOINTTRADEOFFPROFILE_Medium",
  "VIDYO_ENDPOINTTRADEOFFPROFILE_Low",
  "VIDYO_ENDPOINTTRADEOFFPROFILE_LowAlt",
}
export enum VidyoLogLevel {
  "VIDYO_LOGLEVEL_FATAL",
  "VIDYO_LOGLEVEL_ERROR",
  "VIDYO_LOGLEVEL_WARNING",
  "VIDYO_LOGLEVEL_INFO",
  "VIDYO_LOGLEVEL_DEBUG",
  "VIDYO_LOGLEVEL_SENT",
  "VIDYO_LOGLEVEL_RECEIVED",
  "VIDYO_LOGLEVEL_ENTER",
  "VIDYO_LOGLEVEL_LEAVE",
  "VIDYO_LOGLEVEL_INVALID",
}
export enum VidyoMediaFormat {
  "VIDYO_MEDIAFORMAT_IN16",
  "VIDYO_MEDIAFORMAT_FL32",
  "VIDYO_MEDIAFORMAT_NULL",
  "VIDYO_MEDIAFORMAT_I420",
  "VIDYO_MEDIAFORMAT_YU12",
  "VIDYO_MEDIAFORMAT_YUYV",
  "VIDYO_MEDIAFORMAT_YUY2",
  "VIDYO_MEDIAFORMAT_yuvs",
  "VIDYO_MEDIAFORMAT_2vuy",
  "VIDYO_MEDIAFORMAT_UYVY",
  "VIDYO_MEDIAFORMAT_HDYC",
  "VIDYO_MEDIAFORMAT_yuv2",
  "VIDYO_MEDIAFORMAT_yuvu",
  "VIDYO_MEDIAFORMAT_NV12",
  "VIDYO_MEDIAFORMAT_NV21",
  "VIDYO_MEDIAFORMAT_24BG",
  "VIDYO_MEDIAFORMAT_raw",
  "VIDYO_MEDIAFORMAT_BGRA",
  "VIDYO_MEDIAFORMAT_RGBA",
  "VIDYO_MEDIAFORMAT_ARGB",
  "VIDYO_MEDIAFORMAT_BYR1",
  "VIDYO_MEDIAFORMAT_BYR2",
  "VIDYO_MEDIAFORMAT_JPEG",
  "VIDYO_MEDIAFORMAT_MJPG",
  "VIDYO_MEDIAFORMAT_dmb1",
  "VIDYO_MEDIAFORMAT_avc1",
  "VIDYO_MEDIAFORMAT_hvc1",
  "VIDYO_MEDIAFORMAT_M420",
  "VIDYO_MEDIAFORMAT_420f",
  "VIDYO_MEDIAFORMAT_420v",
  "VIDYO_MEDIAFORMAT_Y8",
}
export enum VidyoParticipantApplicationType {
  "VIDYO_PARTICIPANT_APPLICATIONTYPE_None",
  "VIDYO_PARTICIPANT_APPLICATIONTYPE_Recorder",
  "VIDYO_PARTICIPANT_APPLICATIONTYPE_Gateway",
}
export enum VidyoParticipantClearanceType {
  "VIDYO_PARTICIPANT_CLEARANCETYPE_None",
  "VIDYO_PARTICIPANT_CLEARANCETYPE_Member",
  "VIDYO_PARTICIPANT_CLEARANCETYPE_Owner",
  "VIDYO_PARTICIPANT_CLEARANCETYPE_Admin",
  "VIDYO_PARTICIPANT_CLEARANCETYPE_Moderator",
}
export enum VidyoParticipantGetContactResult {
  "VIDYO_PARTICIPANTGETCONTACTRESULT_SUCCESS",
  "VIDYO_PARTICIPANTGETCONTACTRESULT_MiscError",
}
export enum VidyoParticipantHandState {
  "VIDYO_PARTICIPANTHANDSTATE_UNRAISED",
  "VIDYO_PARTICIPANTHANDSTATE_RAISED",
  "VIDYO_PARTICIPANTHANDSTATE_APPROVED",
  "VIDYO_PARTICIPANTHANDSTATE_DISMISSED",
}
export enum VidyoParticipantTrust {
  "VIDYO_PARTICIPANTTRUST_Local",
  "VIDYO_PARTICIPANTTRUST_Federated",
  "VIDYO_PARTICIPANTTRUST_Anonymous",
}
export enum VidyoRole {
  "VIDYO_ROLE_Moderator",
  "VIDYO_ROLE_None",
}
export enum VidyoRoomConferenceHostState {
  "VIDYO_ROOMCONFERENCEHOSTSTATE_JOINED",
  "VIDYO_ROOMCONFERENCEHOSTSTATE_LEFT",
}
export enum VidyoRoomConferenceMode {
  "VIDYO_ROOMCONFERENCEMODE_LOBBY",
  "VIDYO_ROOMCONFERENCEMODE_LECTURE",
  "VIDYO_ROOMCONFERENCEMODE_GROUP",
}
export enum VidyoRoomDeleteResult {
  "VIDYO_ROOMDELETERESULT_OK",
  "VIDYO_ROOMDELETERESULT_NoResponse",
  "VIDYO_ROOMDELETERESULT_Unauthorized",
  "VIDYO_ROOMDELETERESULT_OutOfResources",
  "VIDYO_ROOMDELETERESULT_MiscError",
}
export enum VidyoRoomEnterResult {
  "VIDYO_ROOMENTERRESULT_OK",
  "VIDYO_ROOMENTERRESULT_Cancelled",
  "VIDYO_ROOMENTERRESULT_NoResponse",
  "VIDYO_ROOMENTERRESULT_InvalidPassword",
  "VIDYO_ROOMENTERRESULT_UnknownRoom",
  "VIDYO_ROOMENTERRESULT_RoomFull",
  "VIDYO_ROOMENTERRESULT_NotMember",
  "VIDYO_ROOMENTERRESULT_Banned",
  "VIDYO_ROOMENTERRESULT_MiscLocalError",
  "VIDYO_ROOMENTERRESULT_MiscRemoteError",
}
export enum VidyoRoomExitReason {
  "VIDYO_ROOMEXITREASON_Left",
  "VIDYO_ROOMEXITREASON_ConnectionLost",
  "VIDYO_ROOMEXITREASON_SessionConnectionLost",
  "VIDYO_ROOMEXITREASON_MembershipConnectionLost",
  "VIDYO_ROOMEXITREASON_NoResponse",
  "VIDYO_ROOMEXITREASON_ProtocolViolation",
  "VIDYO_ROOMEXITREASON_Booted",
  "VIDYO_ROOMEXITREASON_ShuttingDown",
  "VIDYO_ROOMEXITREASON_MiscLocalError",
  "VIDYO_ROOMEXITREASON_MiscRemoteError",
}
export enum VidyoRoomGetPropertiesResult {
  "VIDYO_ROOMGETPROPERTIESRESULT_OK",
  "VIDYO_ROOMGETPROPERTIESRESULT_NoResponse",
  "VIDYO_ROOMGETPROPERTIESRESULT_Unauthorized",
  "VIDYO_ROOMGETPROPERTIESRESULT_MiscLocalError",
  "VIDYO_ROOMGETPROPERTIESRESULT_MiscRemoteError",
}
export enum VidyoRoomInCallEventClass {
  "VIDYO_ROOMINCALLEVENTCLASS_MediaTransport",
  "VIDYO_ROOMINCALLEVENTCLASS_InCallCodec",
  "VIDYO_ROOMINCALLEVENTCLASS_UnKnown",
}
export enum VidyoRoomInCallEventCode {
  "VIDYO_ROOMINCALLEVENTCODE_RTCPSendError",
  "VIDYO_ROOMINCALLEVENTCODE_RTCPReceiveError",
  "VIDYO_ROOMINCALLEVENTCODE_RTPSendError",
  "VIDYO_ROOMINCALLEVENTCODE_RTPReceiveError",
  "VIDYO_ROOMINCALLEVENTCODE_EncoderPausedOnLowBW",
  "VIDYO_ROOMINCALLEVENTCODE_EncoderResumed",
  "VIDYO_ROOMINCALLEVENTCODE_InCallCodecVideoH264",
  "VIDYO_ROOMINCALLEVENTCODE_InCallCodecVideoH264SVC",
  "VIDYO_ROOMINCALLEVENTCODE_InCallCodecAudioSPEEXRED",
  "VIDYO_ROOMINCALLEVENTCODE_UnKnown",
}
export enum VidyoRoomInviteResult {
  "VIDYO_ROOMINVITERESULT_OK",
  "VIDYO_ROOMINVITERESULT_NoResponse",
  "VIDYO_ROOMINVITERESULT_Unauthorized",
  "VIDYO_ROOMINVITERESULT_OutOfResources",
  "VIDYO_ROOMINVITERESULT_MiscError",
  "VIDYO_ROOMINVITERESULT_UserIsOffline",
  "VIDYO_ROOMINVITERESULT_ServerError",
  "VIDYO_ROOMINVITERESULT_RoomFull",
}
export enum VidyoRoomMediaDisableReason {
  "VIDYO_ROOMMEDIADISABLEREASON_Disabled",
  "VIDYO_ROOMMEDIADISABLEREASON_SignalingConnectionLost",
  "VIDYO_ROOMMEDIADISABLEREASON_MediaConnectionLost",
  "VIDYO_ROOMMEDIADISABLEREASON_Booted",
  "VIDYO_ROOMMEDIADISABLEREASON_SessionTerminated",
  "VIDYO_ROOMMEDIADISABLEREASON_ServerShuttingDown",
  "VIDYO_ROOMMEDIADISABLEREASON_ConferenceDestroyed",
  "VIDYO_ROOMMEDIADISABLEREASON_MiscLocalError",
  "VIDYO_ROOMMEDIADISABLEREASON_MiscRemoteError",
}
export enum VidyoRoomMediaFailReason {
  "VIDYO_ROOMMEDIAFAILREASON_Cancelled",
  "VIDYO_ROOMMEDIAFAILREASON_NoConference",
  "VIDYO_ROOMMEDIAFAILREASON_SignalingConnectionLost",
  "VIDYO_ROOMMEDIAFAILREASON_MediaConnectionLost",
  "VIDYO_ROOMMEDIAFAILREASON_NoResponse",
  "VIDYO_ROOMMEDIAFAILREASON_InvalidPassword",
  "VIDYO_ROOMMEDIAFAILREASON_RoomIsFull",
  "VIDYO_ROOMMEDIAFAILREASON_InvalidRoomKey",
  "VIDYO_ROOMMEDIAFAILREASON_RoomDisabled",
  "VIDYO_ROOMMEDIAFAILREASON_AllLinesInUse",
  "VIDYO_ROOMMEDIAFAILREASON_ConnectionError",
  "VIDYO_ROOMMEDIAFAILREASON_InvalidRoom",
  "VIDYO_ROOMMEDIAFAILREASON_ConferenceLocked",
  "VIDYO_ROOMMEDIAFAILREASON_SeatLicenseExpired",
  "VIDYO_ROOMMEDIAFAILREASON_NotLicensed",
  "VIDYO_ROOMMEDIAFAILREASON_Rejected",
  "VIDYO_ROOMMEDIAFAILREASON_UnknownError",
  "VIDYO_ROOMMEDIAFAILREASON_MiscLocalError",
  "VIDYO_ROOMMEDIAFAILREASON_MiscRemoteError",
}
export enum VidyoRoomModerationActionType {
  "VIDYO_ROOMMODERATIONACTIONTYPE_Mute",
  "VIDYO_ROOMMODERATIONACTIONTYPE_Unmute",
  "VIDYO_ROOMMODERATIONACTIONTYPE_StartLectureMode",
  "VIDYO_ROOMMODERATIONACTIONTYPE_StopLectureMode",
  "VIDYO_ROOMMODERATIONACTIONTYPE_SetPresenter",
  "VIDYO_ROOMMODERATIONACTIONTYPE_RemovePresenter",
  "VIDYO_ROOMMODERATIONACTIONTYPE_RaiseHand",
  "VIDYO_ROOMMODERATIONACTIONTYPE_UnraiseHand",
  "VIDYO_ROOMMODERATIONACTIONTYPE_DismissRaisedHand",
  "VIDYO_ROOMMODERATIONACTIONTYPE_DismissAllRaisedHands",
  "VIDYO_ROOMMODERATIONACTIONTYPE_SetModeratorPin",
  "VIDYO_ROOMMODERATIONACTIONTYPE_RemoveModeratorPin",
  "VIDYO_ROOMMODERATIONACTIONTYPE_DisconnectAll",
  "VIDYO_ROOMMODERATIONACTIONTYPE_DisconnectOne",
  "VIDYO_ROOMMODERATIONACTIONTYPE_Invalid",
}
export enum VidyoRoomModerationResult {
  "VIDYO_ROOMMODERATIONRESULT_OK",
  "VIDYO_ROOMMODERATIONRESULT_NoResponse",
  "VIDYO_ROOMMODERATIONRESULT_Unauthorized",
  "VIDYO_ROOMMODERATIONRESULT_InvalidInput",
  "VIDYO_ROOMMODERATIONRESULT_MiscLocalError",
  "VIDYO_ROOMMODERATIONRESULT_MiscRemoteError",
}
export enum VidyoRoomModerationType {
  VIDYO_ROOMMODERATIONTYPE_SoftMute = "VIDYO_ROOMMODERATIONTYPE_SoftMute",
  VIDYO_ROOMMODERATIONTYPE_HardMute = "VIDYO_ROOMMODERATIONTYPE_HardMute",
}
export enum VidyoRoomProfileControlMode {
  "VIDYO_ROOMPROFILECONTROLMODE_AlwaysOn",
  "VIDYO_ROOMPROFILECONTROLMODE_AlwaysOff",
  "VIDYO_ROOMPROFILECONTROLMODE_Default",
}
export enum VidyoRoomRecordingState {
  "VIDYO_ROOMRECORDINGSTATE_NotRecording",
  "VIDYO_ROOMRECORDINGSTATE_RecordingPaused",
  "VIDYO_ROOMRECORDINGSTATE_Recording",
}
export enum VidyoRoomRequestRoleChangeResult {
  "VIDYO_ROOMREQUESTROLECHANGERESULT_OK",
  "VIDYO_ROOMREQUESTROLECHANGERESULT_NoResponse",
  "VIDYO_ROOMREQUESTROLECHANGERESULT_Unauthorized",
  "VIDYO_ROOMREQUESTROLECHANGERESULT_MiscLocalError",
  "VIDYO_ROOMREQUESTROLECHANGERESULT_MiscRemoteError",
}
export enum VidyoRoomSearchResult {
  "VIDYO_ROOMSEARCHRESULT_OK",
  "VIDYO_ROOMSEARCHRESULT_NoRecords",
  "VIDYO_ROOMSEARCHRESULT_NoResponse",
  "VIDYO_ROOMSEARCHRESULT_Unauthorized",
  "VIDYO_ROOMSEARCHRESULT_MiscLocalError",
  "VIDYO_ROOMSEARCHRESULT_MiscRemoteError",
}
export enum VidyoRoomSetFavoriteResult {
  "VIDYO_ROOMSETFAVORITERESULT_OK",
  "VIDYO_ROOMSETFAVORITERESULT_NoResponse",
  "VIDYO_ROOMSETFAVORITERESULT_Conflict",
  "VIDYO_ROOMSETFAVORITERESULT_Unauthorized",
  "VIDYO_ROOMSETFAVORITERESULT_NotAcceptable",
  "VIDYO_ROOMSETFAVORITERESULT_NotAllowed",
  "VIDYO_ROOMSETFAVORITERESULT_MiscLocalError",
  "VIDYO_ROOMSETFAVORITERESULT_MiscRemoteError",
}
export enum VidyoRoomSetPropertiesResult {
  "VIDYO_ROOMSETPROPERTIESRESULT_OK",
  "VIDYO_ROOMSETPROPERTIESRESULT_NoResponse",
  "VIDYO_ROOMSETPROPERTIESRESULT_Conflict",
  "VIDYO_ROOMSETPROPERTIESRESULT_Unauthorized",
  "VIDYO_ROOMSETPROPERTIESRESULT_NotOwnerOfRoom",
  "VIDYO_ROOMSETPROPERTIESRESULT_NotAcceptable",
  "VIDYO_ROOMSETPROPERTIESRESULT_NotAllowed",
  "VIDYO_ROOMSETPROPERTIESRESULT_MiscLocalError",
  "VIDYO_ROOMSETPROPERTIESRESULT_MiscRemoteError",
}
export enum VidyoRoomShowThrottle {
  "VIDYO_ROOMSHOWTHROTTLE_NONE",
  "VIDYO_ROOMSHOWTHROTTLE_TIMED",
  "VIDYO_ROOMSHOWTHROTTLE_WINDOWSIZE",
}
export enum VidyoRoomState {
  "VIDYO_ROOMSTATE_Creating",
  "VIDYO_ROOMSTATE_Created",
  "VIDYO_ROOMSTATE_Entering",
  "VIDYO_ROOMSTATE_Entered",
  "VIDYO_ROOMSTATE_MediaRouteAcquiring",
  "VIDYO_ROOMSTATE_MediaRouteAcquired",
  "VIDYO_ROOMSTATE_MediaEnabling",
  "VIDYO_ROOMSTATE_MediaEnabled",
  "VIDYO_ROOMSTATE_MediaDisabling",
  "VIDYO_ROOMSTATE_MediaDisabled",
  "VIDYO_ROOMSTATE_Exiting",
  "VIDYO_ROOMSTATE_Exited",
}
export enum VidyoRoomType {
  "VIDYO_ROOMTYPE_Unknown",
  "VIDYO_ROOMTYPE_Conversation",
  "VIDYO_ROOMTYPE_Topic",
  "VIDYO_ROOMTYPE_Scheduled",
  "VIDYO_ROOMTYPE_Personal",
  "VIDYO_ROOMTYPE_TestCall",
  "VIDYO_ROOMTYPE_Legacy",
}
export enum VidyoRoomWebcastingState {
  "VIDYO_ROOMWEBCASTINGSTATE_NotWebcasting",
  "VIDYO_ROOMWEBCASTINGSTATE_Webcasting",
}
export enum VidyoRoomSearchField {
  "VIDYO_ROOMSEARCHFIELD_Owner",
  "VIDYO_ROOMSEARCHFIELD_Admin",
  "VIDYO_ROOMSEARCHFIELD_Moderator",
  "VIDYO_ROOMSEARCHFIELD_Member",
  "VIDYO_ROOMSEARCHFIELD_User",
  "VIDYO_ROOMSEARCHFIELD_Name",
  "VIDYO_ROOMSEARCHFIELD_Subject",
  "VIDYO_ROOMSEARCHFIELD_Type",
  "VIDYO_ROOMSEARCHFIELD_Public",
  "VIDYO_ROOMSEARCHFIELD_NonMembers",
}
export enum VidyoRoomSearchFieldRelation {
  "VIDYO_ROOMSEARCHFIELDRELATION_AND",
  "VIDYO_ROOMSEARCHFIELDRELATION_OR",
}
export enum VidyoUserAuthType {
  "VIDYO_USERAUTHTYPE_Guest",
  "VIDYO_USERAUTHTYPE_Password",
  "VIDYO_USERAUTHTYPE_AccessToken",
  "VIDYO_USERAUTHTYPE_RefreshToken",
  "VIDYO_USERAUTHTYPE_ProvisionToken",
  "VIDYO_USERAUTHTYPE_Facebook",
  "VIDYO_USERAUTHTYPE_Saml",
  "VIDYO_USERAUTHTYPE_Cac",
}
export enum VidyoUserCallCreateResult {
  "VIDYO_USERCALLCREATERESULT_OK",
  "VIDYO_USERCALLCREATERESULT_NoResponse",
  "VIDYO_USERCALLCREATERESULT_NotAllowed",
  "VIDYO_USERCALLCREATERESULT_MiscLocalError",
  "VIDYO_USERCALLCREATERESULT_MiscRemoteError",
}
export enum VidyoUserConnectionStatusChangedReason {
  "VIDYO_USERCONNECTIONSTATUSCHANGEDREASON_OK",
  "VIDYO_USERCONNECTIONSTATUSCHANGEDREASON_LostContactWithServer",
  "VIDYO_USERCONNECTIONSTATUSCHANGEDREASON_NoCommunicationWithServer",
  "VIDYO_USERCONNECTIONSTATUSCHANGEDREASON_NoValidNetworkInterfaces",
  "VIDYO_USERCONNECTIONSTATUSCHANGEDREASON_NetworkInterfaceChanged",
  "VIDYO_USERCONNECTIONSTATUSCHANGEDREASON_MiscNetworkError",
  "VIDYO_USERCONNECTIONSTATUSCHANGEDREASON_ConnectionError",
}
export enum VidyoUserGetAuthTypesResult {
  "VIDYO_USERGETAUTHTYPESRESULT_OK",
  "VIDYO_USERGETAUTHTYPESRESULT_ConnectionFailed",
  "VIDYO_USERGETAUTHTYPESRESULT_ConnectionLost",
  "VIDYO_USERGETAUTHTYPESRESULT_ConnectionTimeout",
  "VIDYO_USERGETAUTHTYPESRESULT_NoResponse",
  "VIDYO_USERGETAUTHTYPESRESULT_WebProxyAuthenticationFailed",
  "VIDYO_USERGETAUTHTYPESRESULT_TlsFailed",
  "VIDYO_USERGETAUTHTYPESRESULT_ServiceUnavailable",
  "VIDYO_USERGETAUTHTYPESRESULT_MiscLocalError",
  "VIDYO_USERGETAUTHTYPESRESULT_MiscRemoteError",
  "VIDYO_USERGETAUTHTYPESRESULT_UnSupportedTenantVersion",
  "VIDYO_USERGETAUTHTYPESRESULT_NoValidNetworkInterface",
}
export enum VidyoUserGetContactResult {
  "VIDYO_USERGETCONTACTRESULT_OK",
  "VIDYO_USERGETCONTACTRESULT_NoResponse",
  "VIDYO_USERGETCONTACTRESULT_Unauthorized",
  "VIDYO_USERGETCONTACTRESULT_MiscLocalError",
  "VIDYO_USERGETCONTACTRESULT_MiscRemoteError",
}
export enum VidyoUserLoginResult {
  "VIDYO_USERLOGINRESULT_OK",
  "VIDYO_USERLOGINRESULT_ConnectionFailed",
  "VIDYO_USERLOGINRESULT_ConnectionLost",
  "VIDYO_USERLOGINRESULT_ConnectionTimeout",
  "VIDYO_USERLOGINRESULT_NoResponse",
  "VIDYO_USERLOGINRESULT_Terminated",
  "VIDYO_USERLOGINRESULT_InvalidUser",
  "VIDYO_USERLOGINRESULT_InvalidPassword",
  "VIDYO_USERLOGINRESULT_MiscAuthError",
  "VIDYO_USERLOGINRESULT_Cancelled",
  "VIDYO_USERLOGINRESULT_MiscError",
  "VIDYO_USERLOGINRESULT_WebProxyAuthenticationRequired",
  "VIDYO_USERLOGINRESULT_ServiceUnavailable",
  "VIDYO_USERLOGINRESULT_RoomIsFull",
  "VIDYO_USERLOGINRESULT_RoomIsDisabled",
  "VIDYO_USERLOGINRESULT_TlsFailed",
  "VIDYO_USERLOGINRESULT_CertificateVerificationFailed",
  "VIDYO_USERLOGINRESULT_UnsupportedTenantVersion",
  "VIDYO_USERLOGINRESULT_NoValidNetworkInterface",
}
export enum VidyoUserLogoutReason {
  "VIDYO_USERLOGOUTREASON_LoggedOut",
  "VIDYO_USERLOGOUTREASON_ConnectionLost",
  "VIDYO_USERLOGOUTREASON_ConnectionTimeout",
  "VIDYO_USERLOGOUTREASON_NoResponse",
  "VIDYO_USERLOGOUTREASON_Terminated",
  "VIDYO_USERLOGOUTREASON_MiscError",
  "VIDYO_USERLOGOUTREASON_LoggedInElsewhere",
  "VIDYO_USERLOGOUTREASON_NetworkInterfaceChanged",
  "VIDYO_USERLOGOUTREASON_OutOfLicenses",
  "VIDYO_USERLOGOUTREASON_EpClientBadConnection",
  "VIDYO_USERLOGOUTREASON_EpClientBadVersion",
  "VIDYO_USERLOGOUTREASON_EpClientBadSessionId",
  "VIDYO_USERLOGOUTREASON_EpClientBadComms",
  "VIDYO_USERLOGOUTREASON_EpClientRebootRequested",
  "VIDYO_USERLOGOUTREASON_EpClientShutdownRequested",
  "VIDYO_USERLOGOUTREASON_EpClientRestartRequested",
  "VIDYO_USERLOGOUTREASON_EpClientInternalError",
  "VIDYO_USERLOGOUTREASON_EndpointNotBound",
  "VIDYO_USERLOGOUTREASON_InvalidAuth",
  "VIDYO_USERLOGOUTREASON_EpClientStartFailure",
}
export enum VidyoUserRecordingServiceResult {
  "VIDYO_USERRECORDINGSERVICERESULT_Success",
  "VIDYO_USERRECORDINGSERVICERESULT_InvalidArgument",
  "VIDYO_USERRECORDINGSERVICERESULT_GeneralFailure",
  "VIDYO_USERRECORDINGSERVICERESULT_SeatLicenseExpired",
  "VIDYO_USERRECORDINGSERVICERESULT_NotLicensed",
  "VIDYO_USERRECORDINGSERVICERESULT_ResourceNotAvailable",
  "VIDYO_USERRECORDINGSERVICERESULT_ControlMeetingFailure",
}
export enum VidyoUserRoomCreateResult {
  "VIDYO_USERROOMCREATERESULT_OK",
  "VIDYO_USERROOMCREATERESULT_NoResponse",
  "VIDYO_USERROOMCREATERESULT_NotFound",
  "VIDYO_USERROOMCREATERESULT_Unauthorized",
  "VIDYO_USERROOMCREATERESULT_MiscLocalError",
  "VIDYO_USERROOMCREATERESULT_MiscRemoteError",
  "VIDYO_USERROOMCREATERESULT_DuplicateName",
  "VIDYO_USERROOMCREATERESULT_LimitReached",
  "VIDYO_USERROOMCREATERESULT_NotSupported",
}
export enum VidyoUserSearchField {
  "VIDYO_USERSEARCHFIELD_UID",
  "VIDYO_USERSEARCHFIELD_EMAIL",
  "VIDYO_USERSEARCHFIELD_NAME",
  "VIDYO_USERSEARCHFIELD_TELNO",
}
export enum VidyoUserSearchResult {
  "VIDYO_USERSEARCHRESULT_OK",
  "VIDYO_USERSEARCHRESULT_NoRecords",
  "VIDYO_USERSEARCHRESULT_NoResponse",
  "VIDYO_USERSEARCHRESULT_MiscLocalError",
  "VIDYO_USERSEARCHRESULT_MiscRemoteError",
}
export enum VidyoUserState {
  "VIDYO_USERSTATE_Idle",
  "VIDYO_USERSTATE_LoggingIn",
  "VIDYO_USERSTATE_LoggedIn",
  "VIDYO_USERSTATE_Reconnecting",
  "VIDYO_USERSTATE_RequestingAuthenticationTypes",
}
export enum VidyoUserTokenType {
  "VIDYO_USERTOKENTYPE_RefreshToken",
  "VIDYO_USERTOKENTYPE_AccessToken",
}
export enum VidyoMeetingActionResult {
  "VIDYO_MEETINGACTIONRESULT_Ok",
  "VIDYO_MEETINGACTIONRESULT_NoRecord",
  "VIDYO_MEETINGACTIONRESULT_NoResponse",
  "VIDYO_MEETINGACTIONRESULT_Unauthorized",
  "VIDYO_MEETINGACTIONRESULT_MiscLocalError",
  "VIDYO_MEETINGACTIONRESULT_MiscRemoteError",
}
export enum VidyoMeetingAttendeesSearchResult {
  "VIDYO_MEETINGATTENDEESSEARCHRESULT_Ok",
  "VIDYO_MEETINGATTENDEESSEARCHRESULT_IndexOutOfRange",
  "VIDYO_MEETINGATTENDEESSEARCHRESULT_NoRecords",
  "VIDYO_MEETINGATTENDEESSEARCHRESULT_NoResponse",
  "VIDYO_MEETINGATTENDEESSEARCHRESULT_MiscLocalError",
  "VIDYO_MEETINGATTENDEESSEARCHRESULT_MiscRemoteError",
}
export enum VidyoNetworkServiceErrorCode {
  "VIDYO_NETWORKSERVICE_ERRORCODE_Ok",
  "VIDYO_NETWORKSERVICE_ERRORCODE_Error",
  "VIDYO_NETWORKSERVICE_ERRORCODE_MandatoryParamsMissing",
  "VIDYO_NETWORKSERVICE_ERRORCODE_BadRequest",
  "VIDYO_NETWORKSERVICE_ERRORCODE_MaxSimultaneousRequestsReached",
  "VIDYO_NETWORKSERVICE_ERRORCODE_HttpRequestTimeOut",
}
export enum VidyoCalendarConnectParamType {
  "VIDYO_CALENDARCONNECTPARAMTYPE_Unknown",
  "VIDYO_CALENDARCONNECTPARAMTYPE_UserId",
  "VIDYO_CALENDARCONNECTPARAMTYPE_PasswordToken",
  "VIDYO_CALENDARCONNECTPARAMTYPE_Mailbox",
  "VIDYO_CALENDARCONNECTPARAMTYPE_ServerAddress",
}
export enum VidyoAttendeeParticipationRole {
  "VIDYO_ATTENDEEPARTICIPATIONROLE_Chair",
  "VIDYO_ATTENDEEPARTICIPATIONROLE_Required",
  "VIDYO_ATTENDEEPARTICIPATIONROLE_Optional",
  "VIDYO_ATTENDEEPARTICIPATIONROLE_Informational",
}
export enum VidyoAttendeeParticipationStatus {
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_NeedsAction",
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_Organized",
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_Accepted",
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_Declined",
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_Tentative",
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_Delegated",
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_None",
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_Completed",
  "VIDYO_ATTENDEEPARTICIPATIONSTATUS_InProcess",
}
export enum VidyoNetworkInterfaceFamily {
  "VIDYO_NETWORKINTERFACEFAMILY_Unspecified",
  "VIDYO_NETWORKINTERFACEFAMILY_IPV4",
  "VIDYO_NETWORKINTERFACEFAMILY_IPV6",
}
export enum VidyoNetworkInterfaceState {
  "VIDYO_NETWORKINTERFACESTATE_Unknown",
  "VIDYO_NETWORKINTERFACESTATE_Up",
  "VIDYO_NETWORKINTERFACESTATE_Down",
}
export enum VidyoNetworkInterfaceTransportType {
  "VIDYO_NETWORKINTERFACETRANSPORTTYPE_Signaling",
  "VIDYO_NETWORKINTERFACETRANSPORTTYPE_Media",
  "VIDYO_NETWORKINTERFACETRANSPORTTYPE_Data",
}
export enum VidyoNetworkInterfaceType {
  "VIDYO_NETWORKINTERFACETYPE_Other",
  "VIDYO_NETWORKINTERFACETYPE_Wired",
  "VIDYO_NETWORKINTERFACETYPE_WiFi",
  "VIDYO_NETWORKINTERFACETYPE_Wwan",
  "VIDYO_NETWORKINTERFACETYPE_Loopback",
  "VIDYO_NETWORKINTERFACETYPE_Tunneled",
  "VIDYO_NETWORKINTERFACETYPE_NotApplicable",
}
